module.exports = __webpack_public_path__ + "static/img/so5_3.0e4b821.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solution/pic/so5_3.jpg
// module id = oBPK
// module chunks = 11